import { useWorkspace } from "@/hooks/use-workspace";
import { cn } from "@/lib/utils";
import { BarGoButton, BarModeChip, openBarTarget, useBarMode } from "./bar-mode";

/**
 * The bar for the signed-out home: the same bar as the composer without
 * asking, so URLs open and everything else searches the web.
 */
export function WebBar({
  value,
  onValueChange,
  className,
}: {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}) {
  const { activeOrganizationId } = useWorkspace();
  const { mode, modes, cycle, onKeyDown, target } = useBarMode(value, false);

  return (
    <form
      className={cn("flex items-center gap-2.5 py-2 ps-3.5 pe-2", className)}
      onSubmit={(e) => {
        e.preventDefault();
        openBarTarget(target, activeOrganizationId);
      }}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Search the web or type a URL"
        aria-label="Search the web or type a URL"
        autoComplete="off"
        spellCheck={false}
        // biome-ignore lint/a11y/noAutofocus: the new tab exists to type into this bar
        autoFocus
        className="placeholder:text-muted-foreground h-9 min-w-0 flex-1 bg-transparent text-base outline-none"
      />
      <BarModeChip mode={mode} canCycle={modes.length > 1} onCycle={cycle} />
      {mode && mode !== "ask" && (
        <BarGoButton mode={mode} onClick={() => openBarTarget(target, activeOrganizationId)} />
      )}
    </form>
  );
}
